const SvgDislikeOutLined = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24440_1653)">
        <path
          d="M5.125 2C3.5416 2 2.25 3.2916 2.25 4.875V6.51465C2.25 7.27462 2.61923 7.946 3.14111 8.43945C3.41677 8.70002 3.99717 9.44244 4.47363 10.0918C4.9501 10.7412 5.34424 11.313 5.34424 11.313C5.38485 11.3719 5.44146 11.4179 5.50738 11.4457C5.57331 11.4735 5.6458 11.4818 5.71631 11.4697C5.71631 11.4697 5.98079 11.4259 6.23535 11.2412C6.48992 11.0566 6.75244 10.6874 6.75244 10.1733C6.75244 9.95999 6.70871 9.75926 6.65674 9.50342C6.65658 9.50342 6.65641 9.50342 6.65625 9.50342C6.56743 9.06669 6.44017 8.67863 6.26709 8.25H8.38477C9.21309 8.25 9.86151 7.50506 9.74658 6.68457L9.66064 6.07324L9.45068 4.57324L9.3208 3.64258C9.32073 3.64205 9.32039 3.64166 9.32031 3.64111C9.2025 2.70655 8.40207 2 7.45996 2H5.125ZM5.125 2.75H7.45996C8.03032 2.75 8.50529 3.16921 8.57617 3.73535C8.57648 3.73731 8.57681 3.73926 8.57715 3.74121L8.70801 4.67676L8.91797 6.17676L9.00342 6.78857C9.057 7.17109 8.77094 7.5 8.38477 7.5H6.09375C5.86962 7.5 5.65717 7.6342 5.55762 7.81201C5.45806 7.98982 5.44999 8.20469 5.53125 8.39502C5.53125 8.39518 5.53125 8.39535 5.53125 8.39551C5.72479 8.84735 5.8293 9.20012 5.92139 9.65283C5.97291 9.90649 6.00244 10.0797 6.00244 10.1733C6.00244 10.4617 5.90261 10.5557 5.79492 10.6338C5.78953 10.6377 5.79 10.6351 5.78467 10.6387C5.66669 10.4689 5.46503 10.1753 5.07812 9.64795C4.59416 8.98837 4.04734 8.26421 3.65625 7.89453C3.25113 7.51149 3 7.03167 3 6.51465V4.875C3 3.6969 3.9469 2.75 5.125 2.75Z"
          className="fill-current"
        />
      </g>
      <defs>
        <clipPath id="clip0_24440_1653">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgDislikeOutLined;
